// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MiddleTabs_wrap__ro8Qs","tabs":"MiddleTabs_tabs__Qu0x7","activeTab":"MiddleTabs_activeTab__dMcvy"};